import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import CountryEditMain from 'components/CountryEditMain';
import MediaEditor from 'components/MediaEditor';
import SeoTab from 'components/SeoTab';

import { CountryEditTabs_country$key } from '__generated__/CountryEditTabs_country.graphql';
import CountryEditRegions from 'components/CountryEditRegions';

type Props = {
  country: CountryEditTabs_country$key;
};

const CountryEditTabs: FC<Props> = props => {
  const country = useFragment(
    graphql`
      fragment CountryEditTabs_country on Country {
        ...CountryEditMain_country
        ...CountryEditRegions_country
        ...MediaEditor_mediable
        ...SeoTab_seoable
      }
    `,
    props.country
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          component: <CountryEditMain country={country} />,
          hash: 'main',
        },
        {
          title: 'Nuotrauka',
          component: <MediaEditor limit={1} mediable={country} />,
          hash: 'media',
        },
        {
          title: 'Regionai',
          component: <CountryEditRegions country={country} />,
          hash: 'regions',
        },
        {
          title: 'Seo',
          component: <SeoTab type="COUNTRY" seoable={country} />,
          hash: 'seo',
        },
      ]}
    />
  );
};

export default CountryEditTabs;
